import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TicketModel, ITicket, TicketByIDModel } from '@ciptech/classes/ws-ticket';
import { map } from 'rxjs/operators';
import { ITicketWeb, TicketWebModel } from '@ciptech/classes/ws-ticket-web';

@Injectable()
export class WsTicketWebService {
    private endpoint = `/api/WsTicketsWeb`;

    constructor(private http: HttpClient) { }

    insert(ticket: any, files?: any[]): Observable<{ result: any, roles: any[], fueradeHorario: boolean }> {
        ticket.IdTicketWeb = ticket.IdTicketWeb || 0;
        ticket.ws_TicketWebContacto?.forEach((x: any, i: number) => x.Item = i + 1);
        ticket.ws_TicketWebContacto = ticket.ws_TicketWebContacto.filter(x => (x.Nombre || x.IdContacto));
        const formData = new FormData();
        formData.append('ticket', JSON.stringify(ticket));
        //formData.append('Departamento', ticket.Departamento);
        files.forEach((file, index) => formData.append(`file_${index}`, file));
        // formData.append('archivo', ticket.Archivo);

        return this.http.post<{ result: any, roles: any[], fueradeHorario: boolean }>(`${this.endpoint}`, formData, { headers: { context: 'body' } });
    }

    getByPeriodo(anyo: number, IdContacto?: number, ctx?: string): Observable<TicketWebModel[]> { 
        return this.http.get<ITicketWeb[]>(`${this.endpoint}?anyo=${anyo}&IdContacto=${IdContacto}`, { headers: { context: ctx || 'body' } })
            .pipe(
                map(res => res.map(item => new TicketWebModel(item)))
            );
    }

    getTicketWebByID(IdTicketWeb: number, ctx?: string): Observable<any> {
        return this.http.get<any>(`${this.endpoint}/TicketWebById?IdTicketWeb=${IdTicketWeb}`, { headers: { context: ctx || 'body' } })
            .pipe(
                map(res => res)
            );
    }

}